export type AimEntityKind = 'applications' | 'workloads' | 'flows';

export type AimEntityLabels = {
  entitySingular: string;
  entityPlural: string;
  fileSlotName: `${string}File`;
  exampleFileName: string;
  exportFileName: string;
};

export const AIM_ENTITY_LABELS: Record<AimEntityKind, AimEntityLabels> = {
  applications: {
    entitySingular: 'Application',
    entityPlural: 'Applications',
    fileSlotName: 'applicationsFile',
    exampleFileName: 'AIM_Applications_Example',
    exportFileName: 'AIM_Applications',
  },
  workloads: {
    entitySingular: 'Workload',
    entityPlural: 'Workloads',
    fileSlotName: 'workloadsFile',
    exampleFileName: 'AIM_Workloads_Example',
    exportFileName: 'AIM_Workloads',
  },
  flows: {
    entitySingular: 'Flow',
    entityPlural: 'Flows',
    fileSlotName: 'flowsFile',
    exampleFileName: 'AIM_Flows_Example',
    exportFileName: 'AIM_Flows',
  },
};

export const ALL_AIM_ENTITY_KINDS: readonly AimEntityKind[] = [
  'applications',
  'workloads',
  'flows',
] as const;

export const otherKinds = (triggered: AimEntityKind): AimEntityKind[] =>
  ALL_AIM_ENTITY_KINDS.filter((k) => k !== triggered);
